import * as React from 'react';
import { DialogContent } from '@mui/material';
import { AutoAvatar } from '../../../autoAvatar/AutoAvatar';
import { AvatarFromAws } from '../../../avatarFromAws/AvatarFromAws';
import { ContactControl } from '../controls/ContactControls/ContactControl';
import { useStyles } from '../modalVolunteerDetails.styles';
import { IPropsControl } from '../types';

export const Form = (props: IPropsControl): JSX.Element => {
  const classes = useStyles();
  const {
    volunteer,
  } = props;

  return (
    <DialogContent>
      <div className={classes.modalHeader}>
        {
          volunteer?.photoKey && volunteer?.photoKey !== 'no_key'
            ? <AvatarFromAws
              photoKey={volunteer?.photoKey || ''}
              className={classes.volunteerAvatar}
            />
            : <AutoAvatar
              name={`${volunteer?.firstName} ${volunteer?.lastName}`}
              className={classes.volunteerAvatar}
            />
        }
      </div>
      <ContactControl volunteer={volunteer} />
    </DialogContent>
  );
};
